const URLS = {
  ANDROID: {
    'en-eu':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en-eu',
    'de-de':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=de-de',
    'en-de':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en-de',
    'de-at':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=de-at',
    'en-at':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en-at',
    'fr-fr':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=fr-fr',
    'fr-be':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=be-fr',
    'en-fr':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en-fr',
    'en-be':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en-be',
    'it-it':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=it-it',
    'en-it':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en-it',
    'es-es':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=es-es',
    'en-es':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en-es',
    'en-gb':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en_GB',
    'en-ch':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en_CH',
    'de-ch':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=de_CH',
    'en-br':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=en_BR',
    'pt-br':
      'https://play.google.com/store/apps/details?id=de.number26.android&hl=pt_BR',
    'en-us':
      'https://play.google.com/store/apps/details?id=de.number26.android',
    universal:
      'https://play.google.com/store/apps/details?id=de.number26.android',
  },
  IOS: {
    'en-eu': 'https://apps.apple.com/app/n26-the-mobile-bank/id956857223',
    'en-at':
      'https://apps.apple.com/at/app/n26-die-mobile-bank/id956857223?l=en&mt=8',
    'de-at': 'https://apps.apple.com/at/app/n26-die-mobile-bank/id956857223',
    'en-de':
      'https://apps.apple.com/de/app/n26-die-mobile-bank/id956857223?l=en&mt=8',
    'de-de': 'https://apps.apple.com/de/app/n26-die-mobile-bank/id956857223',
    'en-es':
      'https://apps.apple.com/es/app/n26-el-banco-movil/id956857223?l=en&mt=8',
    'es-es': 'https://apps.apple.com/es/app/n26-el-banco-movil/id956857223',
    'en-fr':
      'https://apps.apple.com/fr/app/n26-la-banque-mobile/id956857223?l=en&mt=8',
    'fr-fr': 'https://apps.apple.com/fr/app/n26-la-banque-mobile/id956857223',
    'en-be':
      'https://apps.apple.com/be/app/n26-la-banque-mobile/id956857223?l=en&mt=8',
    'fr-be': 'https://apps.apple.com/be/app/n26-la-banque-mobile/id956857223',
    'en-it':
      'https://apps.apple.com/it/app/n26-la-banca-per-smartphone/id956857223?l=en&mt=8',
    'it-it':
      'https://apps.apple.com/it/app/n26-la-banca-per-smartphone/id956857223',
    'en-gb': 'https://apps.apple.com/gb/app/n26-the-mobile-bank/id956857223',
    'en-ch':
      'https://apps.apple.com/ch/app/n26-die-mobile-bank/id956857223?l=en&mt=8',
    'de-ch':
      'https://apps.apple.com/ch/app/n26-die-mobile-bank/id956857223?l=de',
    'en-br': 'https://apps.apple.com/app/n26-the-mobile-bank/id956857223',
    'pt-br': 'https://apps.apple.com/app/n26-the-mobile-bank/id956857223?l=pt',
    'en-us': 'https://apps.apple.com/app/n26-the-mobile-bank/id956857223',
    universal: 'https://apps.apple.com/app/n26-the-mobile-bank/id956857223',
  },
} as const

export const ANDROID = URLS.ANDROID
export const IOS = URLS.IOS
